import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { ICON_PRESET_COLORS, ICON_PRESET_SIZES, ICON_TYPE, } from "../shared.js";
import { addUnitPx } from "../utils/unit.js";
export default function VanIcon({ className, style, name, size = "inherit", classPrefix = "van-icon", color = "inherit", ...restProps }) {
    const presetColor = ICON_PRESET_COLORS.includes(color);
    const presetSize = ICON_PRESET_SIZES.includes(size);
    return (React.createElement(View, { className: classNames(classPrefix, `${classPrefix}-${name}`, "taroify-icon", {
            [`taroify-icon--${color}`]: presetColor,
            [`taroify-icon--${size}`]: presetSize,
        }, className), style: {
            color: presetColor ? "" : color,
            fontSize: presetSize ? "" : addUnitPx(size),
            ...style,
        }, ...restProps }));
}
export function createVanIconComponent(name) {
    function VanIconWrapper(props) {
        return React.createElement(VanIcon, { name: name, ...props });
    }
    VanIconWrapper[ICON_TYPE] = ICON_TYPE;
    return VanIconWrapper;
}
